<!--
 * @FileDescription: 本科生就业情况展板
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: dcq
 * @LastEditTime: 2023-07-26 12:23:44
 -->
<template>
  <div class="student-tab">
    <KeyValTemplate order="0" :title="graYearNum+'届毕业生落实情况'" :nameValListA=nameValListA keyValId="1" />
    <ArcLayerTemplate order="3" />
    <ChartTemplate v-for="chart in chartsInfo" :key="chart.chartId" :chartId="chart.chartId" :order="chart.order"
      :styleType="chart.styleType" />
  </div>
</template>

<script>
// import activeJson from "@/components/activeChartData.json"
export default {
  name: 'StudentTab',
  data() {
    return {
      graData: [],
      yearArray: [],

      filterGraData: [],


      //页面上加载的数据
      nameValListAll: [],
      // nameValListA: []
      // [
      //   { name: '落实人数', val: '3914' },
      //   { name: '落实率', val: '89.69%' },
      //   { name: '国内升学率', val: '36.07%' },
      //   { name: '国（境）外升学率', val: '7.15%' },
      // ]

    }
  },
  mounted() {
    this.spliceStudent();
    // getUnionYearList();
    // testData();
    
  },
  methods: {
    //拼接
    async spliceStudent() {
      requestApi.getGraList().then((res) => {
        this.graData = res.data.data[0];
        console.log("毕业信息列表", this.graData);

        //获取年份数组
        for (let i = 0; i < this.graData.length; i++) {
          this.yearArray.push(Number(this.graData[i].yearNum))
          // console.log(Number(this.graData[i].yearNum));
        }
        this.yearArray.sort(function (a, b) {
          return a - b;
        })
        console.log(this.yearArray);

        //拼接数据
        for (let j = 0; j < this.yearArray.length; j++) {
          this.filterGraData = this.graData.filter((item) => {
            // console.log("item",item);
            // console.log(this.yearArray[j].yearNum);
            // console.log("转string：",this.yearArray[j].yearNum);
            return item.yearNum == String(this.yearArray[j])
          })
          // console.log("this.filterGraData", this.filterGraData);
          this.nameValListA[0].val = this.filterGraData[0].completeNum
          this.nameValListA[1].val = this.filterGraData[0].completeRate + '%'
          this.nameValListA[2].val = this.filterGraData[0].domesticRate + '%'
          this.nameValListA[3].val = this.filterGraData[0].abroadRate + '%'

          // console.log("this.nameValListA",this.nameValListA);

          this.nameValListAll.push(this.nameValListA)

          this.nameValListA = [
            { name: '落实人数', val: '' },
            { name: '落实率', val: '' },
            { name: '国内升学率', val: '' },
            { name: '国（境）外升学率', val: '' },
          ]
          // console.log("filterGraData", this.filterGraData);
          // String(this.yearArray[i].yearNum)   2019
        }
        console.log("this.nameValListAll", this.nameValListAll);


      })
    }

  },
}
</script>

<script setup>
import { ref ,onMounted } from 'vue';
import requestApi from '@/api/requestApi';
import ChartTemplate from './tabTemplates/ChartTemplate.vue';
import KeyValTemplate from './tabTemplates/KeyValTemplate.vue';
import ArcLayerTemplate from './tabTemplates/ArcLayerTemplate.vue';
import axios from 'axios';
// import {getUnionYearList, testData} from './tabTemplates/chartData'

const chartsInfo = [
  { "chartId": '0', "order": '1', "styleType": '1' },
  { "chartId": '1', "order": '2', "styleType": '2' },
  { "chartId": '2', "order": '4', "styleType": '3' },
  { "chartId": '3', "order": '5', "styleType": '4' },
]

// const nameValListA = [
//   {name: '落实人数', val:'3914'}, 
//   {name: '落实率', val:'89.69%'}, 
//   {name: '国内升学率', val:'36.07%'}, 
//   {name: '国（境）外升学率', val:'7.15%'}, 
// ]
let activeJson=ref({})
let nameValListA = ref([])
let graYearNum = ref("")

// let nameValListA = activeJson.graAll.nameValListA
// let graYearNum = activeJson.graAll.graYearNum

onMounted(() => {
//   console.log(`the component is now mounted.`)
  axios.get('/activeChartData.json')
      .then(response => {
        activeJson.value= response.data;
        nameValListA.value=activeJson.value.graAll.nameValListA
        graYearNum.value = activeJson.value.graAll.graYearNum
      })
      .catch(error => {
        console.log(error);
      });
})
</script>


<style lang="scss">
div.student-tab {
  position: absolute;
  width: 100vw;
  height: 84vh;
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
  // background-color: red;
}
</style>
